/** @jsxRuntime classic */
/** @jsx jsx */
import { Box, Button, Flex, Text } from '@chakra-ui/react';
import { jsx } from '@emotion/react';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';
import './Pagination.css';

const RestaurantList = () => {
  const [restaurants, setRestaurants] = useState([]);
  const itemsPerPage = 20;
  const [pageCount, setPageCount] = useState(1);
  const [page, setPage] = useState(1);
  const [itemOffset, setItemOffset] = useState(0);
  const changeView = 'Restaurants Component';

  useEffect(() => {
    setPageCount(Math.ceil(25359 / itemsPerPage - 1));
    const getRestaurants = async () => {
      const response = await axios.get(
        `https://mern-stack-restaurants-app.herokuapp.com/restaurants?page=${page}&limit=20`
      );
      setRestaurants(response.data);
    };
    getRestaurants();
  }, [page, restaurants.length, itemOffset]);

  const handlePageClick = event => {
    const newOffset = (event.selected * itemsPerPage) % 25359;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`
    );
    setItemOffset(newOffset);
    setPage(Math.floor(newOffset / itemsPerPage + 1));
  };

  return (
    <React.Fragment>
      <Box>
        <Flex direction="row" wrap="wrap" justify="center" mb={10}>
          <ReactPaginate
            breakLabel="..."
            nextLabel="next >"
            onPageChange={handlePageClick}
            pageRangeDisplayed={3}
            pageCount={pageCount}
            previousLabel="< previous"
            renderOnZeroPageCount={null}
            containerClassName={'pagination'}
            previousLinkClassName={'pagination__link'}
            nextLinkClassName={'pagination__link'}
            disabledClassName={'pagination__link--disabled'}
            activeClassName={'pagination__link--active'}
          />
        </Flex>
      </Box>
      <Flex direction="row" wrap="wrap" justify="center">
        {changeView === 'Restaurants Component' &&
          restaurants &&
          restaurants.map((restaurant, index) => {
            const GoogleMapsSearch = `${restaurant.address.building} ${restaurant.address.street}, ${restaurant.address.zipcode}`;
            return (
              <Flex
                key={index}
                direction="column"
                align="center"
                justify="start"
                textAlign="center"
                w="300px"
                border="2px solid #000"
                mb={10}
                mx={5}
                pb={5}
                pt={5}
                bg="#e8ecf1"
                overflow="hidden"
              >
                <Box>
                  <Text fontSize="lg" fontWeight="700" as="u" color="#ff0000">
                    {restaurant.name}
                  </Text>
                  <Text fontSize="lg" color="#000" mt={2}>
                    Cuisine:
                  </Text>
                  <Text fontSize="lg" color="#000">
                    {restaurant.cuisine}
                  </Text>
                  <Text fontSize="lg" color="#000" mt={2}>
                    Address:
                  </Text>
                  <Text fontSize="lg" color="#000">
                    {restaurant.address.street},{restaurant.address.zipcode}
                  </Text>
                  <Box mb={3}>
                    <Flex mt={3} direction="row" wrap="wrap" justify="center">
                      <Button
                        bg="#f9bf3b"
                        _hover={{
                          background: '#ff0000',
                          color: '#fff',
                        }}
                      >
                        <Link to={`/write/${restaurant._id}`}>
                          Write Review
                        </Link>
                      </Button>
                      <Button
                        ml={2}
                        bg="#f9bf3b"
                        _hover={{
                          background: '#ff0000',
                          color: '#fff',
                        }}
                      >
                        <Link to={`/view/${restaurant._id}`}>View Reviews</Link>
                      </Button>
                    </Flex>
                  </Box>
                  <Button
                    bg="#f9bf3b"
                    _hover={{
                      background: '#ff0000',
                      color: '#fff',
                    }}
                  >
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={
                        'https://www.google.com/maps/place/' + GoogleMapsSearch
                      }
                    >
                      View Map
                    </a>
                  </Button>
                </Box>
              </Flex>
            );
          })}
      </Flex>
    </React.Fragment>
  );
};

export default RestaurantList;
